<template>
  <section class="info-cards">
    <div class="info-cards__inner">
      <Heading
        v-if="heading"
        class="font-bold"
        v-bind="heading"
        level="h4"
      />
      <Swiper
        ref="cardSwiper"
        class="info-cards__cards"
        :options="swiperOptions"
      >
        <SwiperSlide
          v-for="(slide, index) in items"
          :key="`slide-${index}`"
          class="info-cards__slide"
        >
          <InfoCard
            v-for="(item, slideIndex) in slide"
            :key="slideIndex"
            class="info-cards__item"
            v-bind="item"
          />
        </SwiperSlide>
      </Swiper>
      <div class="info-cards__footer">
        <div v-if="items.length > 4" class="info-cards__pagination"></div>
        <slot />
      </div>
    </div>
  </section>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import InfoCard from '@/components/partials/InfoCard.vue'
import Heading from '@/components/heading/Heading.vue'
import 'swiper/css/swiper.css'

export default {
  components: {
    InfoCard,
    Heading,
    Swiper,
    SwiperSlide
  },
  props: {
    heading: {
      type: Object,
      default: () => {}
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      swiperOptions: {
        init: this.items.length > 4,
        pagination: {
          el: '.info-cards__pagination',
          type: 'bullets',
          clickable: true
        }
      },
      forcePosition: false
    }
  }
}
</script>

<style lang="scss">
.info-cards {
  position: relative;
  z-index: 1;
  padding: 0 $padding;
  margin-top: $info-cards-overlap;
  color: $info-cards-color;
  .heading {
    margin-top: 0;
    padding: 0;
  }
  &__inner {
    background: $info-cards-background;
    & > .meta,
    & > .heading {
      display: block;
      padding-bottom: $info-cards-padding;
    }
    @if $info-cards-space-around {
      padding: $info-cards-padding;
    }
    @else {
      & > .meta {
        padding: $info-cards-padding;
      }
      .info-cards__footer {
        padding: 0 $info-cards-padding $info-cards-padding;
      }
    }
  }
  &__slide {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
  }
  &__item {
    width: 50%;
  }
  &__pagination {
    display: flex;
    justify-content: $info-cards-bullets-align;
    width: 100%;
    .swiper-pagination-bullet {
      display: inline-block;
      margin: $info-cards-bullets-margin;
      background-color: $info-cards-bullets-inactive-color;
      opacity: 1;
    }
    .swiper-pagination-bullet-active {
      background-color: $info-cards-bullets-active-color;
    }
  }
  .button {
    margin-top: rem(20);
  }
}
</style>

<docs>
  ```vue
  <InfoCards card-type="link" label="Label" title="Title" :info="[{ icon: 'destination', text: 'Text' }, { icon: 'chat', text: 'Text' }, { icon: 'edit', text: 'Text' }, { icon: 'destination', text: 'Text' }, { icon: 'destination', text: 'Text' }]" />
  ```
</docs>
